import * as fabric from 'office-ui-fabric-react';
import React, { VFC } from 'react';

interface IProps {
    deviceId: number;
    device: string;
}

const DeviceLinkCell: VFC<IProps> = ({ deviceId, device }) => {
    return (
        <td>
            <fabric.Link target="_blank" href={`${window.location.origin}/display/${device}/${deviceId}`}>
                <fabric.Icon iconName="FileSymlink" style={{ fontSize: 20 }} />
            </fabric.Link>
        </td>
    );
};

export default DeviceLinkCell;
